import React from "react";
import { SvgIcon, SvgIconProps } from "@mui/material";
const AppIconsElaborated = React.forwardRef((props: SvgIconProps, ref: any) => {
  return (
    <SvgIcon {...props} ref={ref}>
      <g fill="currentColor">
        <path
          d="M22.3513641,7.6157465L22.3513641,7.6157465c-0.5642776-1.3351598-1.3751488-2.5325813-2.4059525-3.5611644
		c-1.0308037-1.0285842-2.2326698-1.8350112-3.5700512-2.3992872c-1.3862553-0.5820496-2.8569288-0.8775171-4.3742571-0.8775171
		S9.0131025,1.0754663,7.6268482,1.6597383C6.2894673,2.2262354,5.0876012,3.0348847,4.056797,4.06569
		C3.0259917,5.0987167,2.2173438,6.2983603,1.6508453,7.6357398c-0.586493,1.3862557-0.8819605,2.8569303-0.8819605,4.3742566
		s0.2976885,2.9880018,0.8819605,4.3698139c0.5664985,1.3351574,1.3751464,2.5348015,2.4059517,3.5633869
		c1.0308056,1.0285835,2.2326703,1.8350086,3.5700512,2.3992863c1.3840332,0.5820503,2.8569288,0.8797379,4.3720341,0.8797379
		c1.5173273,0,2.9880018-0.2976894,4.374258-0.8819599c1.3373795-0.5664978,2.5392456-1.3751469,3.5700493-2.4059525
		c1.0308056-1.0308037,1.8416767-2.2326698,2.4059525-3.5700493c0.5864925-1.3840342,0.8819599-2.8569307,0.8819599-4.374258
		C23.2333241,10.4704542,22.9378567,8.9997797,22.3513641,7.6157465z M22.0958843,12.0099964
		c0,5.5650139-4.527544,10.0947781-10.0947809,10.0947781c-5.5650134,0-10.0947781-4.527544-10.0947781-10.094779
		S6.43609,1.9152167,12.0011034,1.9152167s10.0947809,4.5297651,10.0947809,10.094779V12.0099964z"
        />
        <polygon
          points="9.8173084,15.5600529 6.4072099,12.1010799 5.7518487,12.7942076 9.8261948,16.9685249 18.2525806,7.7112732 
		17.561676,7.0559125 	"
        />
      </g>
    </SvgIcon>
  );
});

export default AppIconsElaborated;
